































import VueOptions from '@utils/VueOptions'
import WizardService from '@services/Wizard'

settings =
  name: "InventorySelectorStep"

  vue:
    props: ['wizard']
    mixins: [WizardService.step()]

    computed:
      errorNoInventorySelected: -> @wizard.validationErrors.stepErrors.inventory?
      errorInventoryConflict: -> @wizard.validationFormErrors.inventory_conflict?

      partnerBuyConfig: -> @wizard.partnerBuy?.config? || {}

      imagesForSamplingActivation: ->
        image = @partnerBuyConfig.spaces?.categories?.sampling?.url
        image ||= @imageFor("spaces", "activation-example-sampling-1.png")
        [image]
      imagesForVideoWallActivation: ->
        image = @partnerBuyConfig.spaces?.categories?.media?.url
        image ||= @imageFor("spaces", "activation-example-video-wall-1.png")
        [image]
      imagesForOnsiteSpaceActivation: ->
        image = @partnerBuyConfig.spaces?.categories?.booth?.url
        image ||= @imageFor("spaces", "activation-example-onsite-space-1.jpg")
        [image]
      imagesForDigitalActivation: ->
        [
          @imageFor("spaces", "activation-example-digital-1.png")
        ]

      partnerBuyConfig: -> @wizard.partnerBuy?.config || {}

    methods:
      validateStep: ->
        @validateInventory()

      validateInventory: ->
        selected = !!Object.values(@wizard.creatives).length
        unless selected
          @wizard.setStepError 'inventory', 'No Inventory Is Selected'
          @wizard.setFormError 'inventory', 'Please select at least 1'

        { product_sampling, onsite_space } = @wizard.creatives
        if product_sampling and onsite_space
          @wizard.setStepError 'inventory_conflict', 'Please request the organizer to distribute your items or go onsite yourself, but not both!'
          @wizard.setFormError 'inventory_conflict', 'Please request the organizer to distribute your items or go onsite yourself, but not both!'

      inventoryBoxStyle: (hasInventory, hasError) ->
        style = 'border border-recess opacity-100 bg-recess-glass' if hasInventory
        style = 'border border-recess-error opacity-100 bg-recess-glass' if hasError
        style

      spaceCategoryIsAvailble: (category) ->
        return true unless @partnerBuyConfig.spaces?
        @partnerBuyConfig.spaces?.categories?[category]?

      hiToggleInventoryType: (type, key) ->
        key ||= type
        if @wizard.creatives[key]?.length
          @wizard.removeCreativeType type, key
        else
          @wizard.setCreativeType type, key

    watch:
      "wizard.creatives": -> @wizard.clearValidationErrors()

export default VueOptions.vue settings
